import { FunctionComponent } from 'react';
import * as vp from 'vopay';
import * as Yup from 'yup';
import { Formik } from 'formik';
import type { FileTemplateHandler, FileTemplateForm } from './types';

import { buildFileUploadRows } from './buildFileTemplateRows.helper';
import { useClientData } from '@/providers/ClientData.provider';

const { Box, Button, Table, TextField, Select, TextArea, InputFile } = vp;

type FileTemplateProps = {
  handlers: FileTemplateHandler;
  defaultValues: FileTemplateForm;
};

type FC = FunctionComponent<FileTemplateProps>;
const FileTemplateDownloadForm: FC = (props: FileTemplateProps) => {
  const { handlers, defaultValues } = props;
  const {
    response: { Country },
  } = useClientData();

  const fileUploadRow = buildFileUploadRows(Country);

  return (
    <Formik
      initialValues={defaultValues}
      onSubmit={handlers.onDownload}
      validationSchema={createdValidationSchema()}
      validateOnChange
      validateOnBlur
    >
      {({ values, touched, errors, handleChange, handleBlur, handleSubmit }) => {
        const ticketsTable: vp.TableProps = {
          name: 'add-user-fields',
          variant: 'pair',
          columns: {
            Field: { header: 'Labels' },
            Input: { header: 'Fields' },
          },
          rows: fileUploadRow
            .filter((x) => x.visible(values))
            .map(({ label, id, preset, type, idFileName, getSelectOptions }) => ({
              Field: label,
              Input: getField(id, preset, type, getSelectOptions, idFileName),
            })),
        };

        return (
          <form onSubmit={handleSubmit}>
            <Table {...ticketsTable} />

            <Box mt="md" jc="fe">
              <Button id="CreateTicket-submit" type="submit" label="Download" />
            </Box>
          </form>
        );
        function getField(
          id: vp.FileTemplateId,
          preset: keyof vp.TextFieldPresets | undefined,
          type: 'input' | 'select' | 'textarea' | 'inputfile',
          getSelectOptions: () => {
            [key: string]: string;
          },
          idFileName?: vp.FileTemplateId,
        ) {
          switch (type) {
            case 'select':
              return (
                <Select
                  variant="standard"
                  options={getSelectOptions()}
                  key={id}
                  name={id}
                  value={values[id]}
                  placeholder=""
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={errors[id] && touched[id] ? errors[id] : null}
                />
              );
            case 'input':
              return (
                <TextField
                  preset={preset}
                  key={id}
                  name={id}
                  variant="standard"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  error={errors[id] && touched[id] ? errors[id] : null}
                />
              );
            case 'inputfile':
              return (
                <InputFile
                  id={id}
                  key={id}
                  name={id}
                  idFileName={idFileName}
                  valueFileName={idFileName ? values[idFileName] : undefined}
                  variant="standard"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  onBlurFileName={handleBlur}
                  onChangeFileName={handleChange}
                  label="Upload File"
                />
              );
            default:
              return <TextArea key={id} name={id} onBlur={handleBlur} onChange={handleChange} maxLength={5000} />;
          }
        }
      }}
    </Formik>
  );
  function createdValidationSchema() {
    return Yup.object().shape({});
  }
};

export default FileTemplateDownloadForm;
